import { BaseSignalr } from './signalr.js';
import { CrossTabPushMessageType } from './types/openlogin.js';
export class OpenloginSignalr extends BaseSignalr {
    onAuthStatusChanged({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onAuthStatusChanged, (data) => {
            console.log(CrossTabPushMessageType.onAuthStatusChanged, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body);
            }
            else {
                callback(null);
            }
        });
    }
    onSetLoginGuardianResult({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onSetLoginGuardianResult, (data) => {
            console.log(CrossTabPushMessageType.onSetLoginGuardianResult, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body, CrossTabPushMessageType.onSetLoginGuardianResult);
            }
            else {
                callback(null);
            }
        });
    }
    onAddGuardianResult({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onAddGuardianResult, (data) => {
            console.log(CrossTabPushMessageType.onAddGuardianResult, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body, CrossTabPushMessageType.onAddGuardianResult);
            }
            else {
                callback(null);
            }
        });
    }
    onEditGuardianResult({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onEditGuardianResult, (data) => {
            console.log(CrossTabPushMessageType.onEditGuardianResult, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body, CrossTabPushMessageType.onEditGuardianResult);
            }
            else {
                callback(null);
            }
        });
    }
    onGuardianApprovalResult({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onGuardianApprovalResult, (data) => {
            console.log(CrossTabPushMessageType.onGuardianApprovalResult, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body);
            }
            else {
                callback(null);
            }
        });
    }
    onRemoveGuardianResult({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onRemoveGuardianResult, (data) => {
            console.log(CrossTabPushMessageType.onRemoveGuardianResult, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body, CrossTabPushMessageType.onRemoveGuardianResult);
            }
            else {
                callback(null);
            }
        });
    }
    onCheckSellResult({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onCheckSellResult, (data) => {
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body);
            }
            else {
                callback(null);
            }
        });
    }
    onTransferSettingApproval({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onTransferSettingApproval, (data) => {
            console.log(CrossTabPushMessageType.onTransferSettingApproval, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body, CrossTabPushMessageType.onTransferSettingApproval);
            }
            else {
                callback(null);
            }
        });
    }
    onSendOneTimeApproval({ requestId }, callback) {
        return this.listen(CrossTabPushMessageType.onSendOneTimeApproval, (data) => {
            console.log(CrossTabPushMessageType.onSendOneTimeApproval, data, requestId);
            if ((data === null || data === void 0 ? void 0 : data.requestId) === requestId) {
                callback(data.body, CrossTabPushMessageType.onSendOneTimeApproval);
            }
            else {
                callback(null);
            }
        });
    }
    GetTabDataAsync({ requestId, methodName }) {
        return this.invoke('GetTabDataAsync', {
            clientId: requestId,
            methodName,
        });
    }
}
export const openloginListenList = [
    CrossTabPushMessageType.onAddGuardianResult,
    CrossTabPushMessageType.onEditGuardianResult,
    CrossTabPushMessageType.onGuardianApprovalResult,
    CrossTabPushMessageType.onGuardianApprovalResult,
    CrossTabPushMessageType.onRemoveGuardianResult,
    CrossTabPushMessageType.onSetLoginGuardianResult,
    CrossTabPushMessageType.onAuthStatusChanged,
    CrossTabPushMessageType.onCheckSellResult,
];
export const openloginSignal = new OpenloginSignalr({
    listenList: openloginListenList,
});
